import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Startup-Head" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { "txt-center": "" }
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = {
  "m-tb-0": "",
  "f-w-700": ""
}
const _hoisted_6 = {
  "m-tb-0": "",
  "f-w-600": "",
  "mute-primary": ""
}
const _hoisted_7 = { "mute-secondary": "" }
const _hoisted_8 = { "mute-secondary": "" }
const _hoisted_9 = {
  key: 0,
  style: {"padding-left":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_app_ent_standing = _resolveComponent("app-ent-standing")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.business !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_avatar, {
                src: _ctx.business.avatar,
                icon: "el-icon-office-building",
                "m-lr-auto": "",
                size: 150
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.name)), 1),
              _createElementVNode("h3", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.business.stage) + " Stage ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                  "mute-secondary": "",
                  style: {"padding-left":"10px","padding-right":"10px"}
                }, " | ", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.business.industry) + " Industry ", 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.business.businessModel) + " Business Model ", 1)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.business.coFoundersSize + 1) + " Founders", 1),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.business.location)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.business.location.description), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_app_ent_standing, {
              class: "App-Ent-Standing",
              labelSelf: `${_ctx.$filters.capitalize(
            _ctx.$filters.slice(_ctx.business.name, 30)
          )}`,
              standingSelf: _ctx.business.standing,
              size: "medium"
            }, null, 8, ["labelSelf", "standingSelf"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}